// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./mrrobot.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-bordered {
  border: 1px solid #ebebeb;
  /* width: 100vw; */
}

.card {
  border: 0;
  border-radius: 0px;
  margin-bottom: 30px;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.03);
  transition: 0.5s;
}

.padding {
  padding: 1rem 0rem !important;
}

body {
  background-color: #f9f9fa;
}

.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: transparent;
  border-bottom: 1px solid rgba(77, 82, 89, 0.07);
}

.card-header .card-title {
  padding: 0;
  border: none;
}

h4.card-title {
  font-size: 17px;
}

.card-header > *:last-child {
  margin-right: 0;
}

.card-header > * {
  margin-left: 8px;
  margin-right: 8px;
}

.btn-secondary {
  /* color: #4d5259 !important; */
  /* background-color: #e4e7ea; */
  border-color: #e4e7ea;
  color: #fff;
}

.btn-xs {
  font-size: 11px;
  padding: 2px 8px;
  line-height: 18px;
}
.btn-xs:hover {
  color: #fff !important;
}

.card-title {
  /* font-family: Roboto, sans-serif; */
  font-weight: 300;
  line-height: 1.5;
  margin-bottom: 0;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(77, 82, 89, 0.07);
}

.ps-container {
  position: relative;
}

.ps-container {
  touch-action: auto;
  overflow: hidden !important;
  -ms-overflow-style: none;
}

.media-chat {
  padding-right: 64px;
  margin-bottom: 0;
}

.media {
  padding: 16px 12px;
  transition: background-color 0.2s linear;
}

.media .avatar {
  flex-shrink: 0;
}

.avatar {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  border-radius: 100%;
  background-color: #f5f6f7;
  color: #8b95a5;
  text-transform: uppercase;
}

.media-chat .media-body {
  flex: initial;
  display: table;
  width: 80%;
}

.media-body {
  min-width: 0;
}

.media-chat .media-body p {
  position: relative;
  padding: 6px 8px;
  margin: 4px 0;
  background-color: #f5f6f7;
  border-radius: 3px;
  font-weight: 100;
  color: #fff;
}

.media > * {
  margin: 0 8px;
}

.media-chat .media-body p.meta {
  background-color: transparent !important;
  padding: 0;
  opacity: 0.8;
}

.media-meta-day {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  color: #8b95a5;
  opacity: 0.8;
  font-weight: 400;
}

.media {
  padding: 16px 12px;
  transition: background-color 0.2s linear;
}

.media-meta-day::before {
  margin-right: 16px;
}

.media-meta-day::before,
.media-meta-day::after {
  content: '';
  flex: 1 1;
  border-top: 1px solid #ebebeb;
}

.media-meta-day::after {
  content: '';
  flex: 1 1;
  border-top: 1px solid #ebebeb;
}

.media-meta-day::after {
  margin-left: 16px;
}

.media-chat.media-chat-reverse {
  padding-right: 12px;
  padding-left: 64px;
  flex-direction: row-reverse;
}

.media-chat {
  padding-right: 64px;
  margin-bottom: 0;
}

.media {
  padding: 16px 12px;
  transition: background-color 0.2s linear;
}

.media-chat.media-chat-reverse .media-body p {
  float: right;
  clear: right;
  background-color: #f38909;
  color: #fff;
}

.media-chat .media-body p {
  position: relative;
  padding: 6px 8px;
  margin: 4px 0;
  background-color: #feb904;
  border-radius: 3px;
}

.border-light {
  border-color: #f1f2f3 !important;
}

.bt-1 {
  border-top: 1px solid #ebebeb !important;
}

.publisher {
  position: relative;
  display: flex;
  align-items: center;
  padding: 12px 20px;
  border: 2px solid #5f5555 !important;
  border-radius: 10rem !important;
  /* background-color: #f9fafb; */
}

.copybtn {
  visibility: hidden;
}

.copybtn:hover {
  visibility: hidden;
}

.publisher > *:first-child {
  margin-left: 0;
}

.publisher > * {
  margin: 0 8px;
}

.publisher-input {
  flex-grow: 1;
  border: none;
  color: white;
  /* font-weight: bold; */
  outline: none !important;
  background-color: transparent;
}

button,
input,
optgroup,
select,
textarea {
  /* font-family: Roboto, sans-serif; */
  font-weight: 300;
}

.publisher-btn {
  background-color: transparent;
  border: none;
  color: #8b95a5;
  font-size: 16px;
  cursor: pointer;
  overflow: -moz-hidden-unscrollable;
  transition: 0.2s linear;
}

.file-group {
  position: relative;
  overflow: hidden;
}

.publisher-btn {
  background-color: transparent;
  border: none;
  color: #cac7c7;
  font-size: 16px;
  cursor: pointer;
  overflow: -moz-hidden-unscrollable;
  transition: 0.2s linear;
}

.file-group input[type='file'] {
  position: absolute;
  opacity: 0;
  z-index: -1;
  width: 20px;
}

.text-info {
  color: #48b0f7 !important;
}

.overFLOW {
  overflow-y: scroll !important;
  height: 450px !important;
}

.no-overFLOW {
  /* overflow: hidden !important; */
  /* overflow-y: hidden !important;
  overflow-x: hidden !important; */
}

.polaroid {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  text-align: center;
}

.bg-color-lite {
  background-color: #d8d8d8;
}

.customChatContainer {
  width: 80vw !important;
}

.copy-icon {
  transition: all 0.2s;
}

.copy-icon:active {
  /* background-color: gray; */
  /* border-radius: 10rem; */
}

.copy-icon:hover {
  filter: brightness(1.05);
  transform: translateY(-5px);
  /* box-shadow: 0px 30px 200px rgba(255, 255, 255, 0.7); */
}

@font-face {
  font-family: 'SamuraiFont';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  /* src: url('./nothing.ttf') format('truetype'); */
}

.nothing-font {
  font-family: 'SamuraiFont', sans-serif;
}

.btn-and-loader {
  display: flex !important;
}
.tl-update-loader {
  margin-top: 0.5rem;
  margin-left: 0.5rem;
  padding: 0.8rem;
}

.privacy-btn {
  border: none !important;
}

.float-right {
  float: right;
}
.teams-container img {
  width: fit-content;
  margin: 0 auto;
}
.jtk-demo-canvas {
  height: 88vh !important;
}
.footer {
  position: absolute !important;
  bottom: 0 !important;
  margin: 0 !important;
  left: 0;
  right: 0;
  padding: 0 !important;
}

.teams-container .MuiCardHeader-content {
  color: #ebebeb !important;
}

.teams-container .MuiCardHeader-subheader {
  color: #ebebeb !important;
}

.teams-container .MuiSvgIcon-root {
  color: #ebebeb !important;
}
.teams-container .MuiChip-filled {
  color: #ebebeb !important;
}
.h-v_center {
  /* position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
  float: right;
}
.licenseDetails {
  display: inline-block;
  padding: 0.7rem 1rem;
  border-radius: 10px;
  margin-bottom: 5px;
  background-color: #1f1d1d;
  color: rgb(163, 193, 217);
}
.license_d-flex {
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(25% - 30px);
}
.license-details {
  /* border: 3px solid rgb(67, 63, 63); */
  padding: 10px;
  margin: 0 auto;
}
.license-details p {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.browse {
  border-left: 2px solid gray;
  background-color: gray;
  padding: 1rem;
  position: relative;
  right: -1rem;
}

.license_modal .modal-content {
  width: 70% !important;
  margin: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/modules/private/pages/styles.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EAEnB,yCAAyC;EAEzC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EAEE,aAAa;EAEb,8BAA8B;EAE9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAEE,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAElB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EAEE,aAAa;EACb,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,UAAU;EACV,YAAY;AACd;;AAEA;EAEE,8BAA8B;EAE9B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAElB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EAEX,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EAEX,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAGlB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAElB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAElB,aAAa;EAEb,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EAEE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;;;;;EAKE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,kCAAkC;EAElC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,kCAAkC;EAElC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC;kCACgC;AAClC;;AAEA;EACE,4EAA4E;EAC5E,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE,0BAA0B;EAC1B,+DAA4C;EAC5C,kDAAkD;AACpD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,oBAAoB;EACpB,OAAO;EACP,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;;;qCAGmC;EACnC,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;AAC5B;AACA;EACE,uCAAuC;EACvC,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB","sourcesContent":[".card-bordered {\r\n  border: 1px solid #ebebeb;\r\n  /* width: 100vw; */\r\n}\r\n\r\n.card {\r\n  border: 0;\r\n  border-radius: 0px;\r\n  margin-bottom: 30px;\r\n  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.03);\r\n  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.03);\r\n  -webkit-transition: 0.5s;\r\n  transition: 0.5s;\r\n}\r\n\r\n.padding {\r\n  padding: 1rem 0rem !important;\r\n}\r\n\r\nbody {\r\n  background-color: #f9f9fa;\r\n}\r\n\r\n.card-header:first-child {\r\n  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;\r\n}\r\n\r\n.card-header {\r\n  display: -webkit-box;\r\n  display: flex;\r\n  -webkit-box-pack: justify;\r\n  justify-content: space-between;\r\n  -webkit-box-align: center;\r\n  align-items: center;\r\n  padding: 15px 20px;\r\n  background-color: transparent;\r\n  border-bottom: 1px solid rgba(77, 82, 89, 0.07);\r\n}\r\n\r\n.card-header .card-title {\r\n  padding: 0;\r\n  border: none;\r\n}\r\n\r\nh4.card-title {\r\n  font-size: 17px;\r\n}\r\n\r\n.card-header > *:last-child {\r\n  margin-right: 0;\r\n}\r\n\r\n.card-header > * {\r\n  margin-left: 8px;\r\n  margin-right: 8px;\r\n}\r\n\r\n.btn-secondary {\r\n  /* color: #4d5259 !important; */\r\n  /* background-color: #e4e7ea; */\r\n  border-color: #e4e7ea;\r\n  color: #fff;\r\n}\r\n\r\n.btn-xs {\r\n  font-size: 11px;\r\n  padding: 2px 8px;\r\n  line-height: 18px;\r\n}\r\n.btn-xs:hover {\r\n  color: #fff !important;\r\n}\r\n\r\n.card-title {\r\n  /* font-family: Roboto, sans-serif; */\r\n  font-weight: 300;\r\n  line-height: 1.5;\r\n  margin-bottom: 0;\r\n  padding: 15px 20px;\r\n  border-bottom: 1px solid rgba(77, 82, 89, 0.07);\r\n}\r\n\r\n.ps-container {\r\n  position: relative;\r\n}\r\n\r\n.ps-container {\r\n  -ms-touch-action: auto;\r\n  touch-action: auto;\r\n  overflow: hidden !important;\r\n  -ms-overflow-style: none;\r\n}\r\n\r\n.media-chat {\r\n  padding-right: 64px;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.media {\r\n  padding: 16px 12px;\r\n  -webkit-transition: background-color 0.2s linear;\r\n  transition: background-color 0.2s linear;\r\n}\r\n\r\n.media .avatar {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.avatar {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 36px;\r\n  height: 36px;\r\n  line-height: 36px;\r\n  text-align: center;\r\n  border-radius: 100%;\r\n  background-color: #f5f6f7;\r\n  color: #8b95a5;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.media-chat .media-body {\r\n  -webkit-box-flex: initial;\r\n  flex: initial;\r\n  display: table;\r\n  width: 80%;\r\n}\r\n\r\n.media-body {\r\n  min-width: 0;\r\n}\r\n\r\n.media-chat .media-body p {\r\n  position: relative;\r\n  padding: 6px 8px;\r\n  margin: 4px 0;\r\n  background-color: #f5f6f7;\r\n  border-radius: 3px;\r\n  font-weight: 100;\r\n  color: #fff;\r\n}\r\n\r\n.media > * {\r\n  margin: 0 8px;\r\n}\r\n\r\n.media-chat .media-body p.meta {\r\n  background-color: transparent !important;\r\n  padding: 0;\r\n  opacity: 0.8;\r\n}\r\n\r\n.media-meta-day {\r\n  -webkit-box-pack: justify;\r\n  justify-content: space-between;\r\n  -webkit-box-align: center;\r\n  align-items: center;\r\n  margin-bottom: 0;\r\n  color: #8b95a5;\r\n  opacity: 0.8;\r\n  font-weight: 400;\r\n}\r\n\r\n.media {\r\n  padding: 16px 12px;\r\n  -webkit-transition: background-color 0.2s linear;\r\n  transition: background-color 0.2s linear;\r\n}\r\n\r\n.media-meta-day::before {\r\n  margin-right: 16px;\r\n}\r\n\r\n.media-meta-day::before,\r\n.media-meta-day::after {\r\n  content: '';\r\n  -webkit-box-flex: 1;\r\n  flex: 1 1;\r\n  border-top: 1px solid #ebebeb;\r\n}\r\n\r\n.media-meta-day::after {\r\n  content: '';\r\n  -webkit-box-flex: 1;\r\n  flex: 1 1;\r\n  border-top: 1px solid #ebebeb;\r\n}\r\n\r\n.media-meta-day::after {\r\n  margin-left: 16px;\r\n}\r\n\r\n.media-chat.media-chat-reverse {\r\n  padding-right: 12px;\r\n  padding-left: 64px;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: reverse;\r\n  flex-direction: row-reverse;\r\n}\r\n\r\n.media-chat {\r\n  padding-right: 64px;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.media {\r\n  padding: 16px 12px;\r\n  -webkit-transition: background-color 0.2s linear;\r\n  transition: background-color 0.2s linear;\r\n}\r\n\r\n.media-chat.media-chat-reverse .media-body p {\r\n  float: right;\r\n  clear: right;\r\n  background-color: #f38909;\r\n  color: #fff;\r\n}\r\n\r\n.media-chat .media-body p {\r\n  position: relative;\r\n  padding: 6px 8px;\r\n  margin: 4px 0;\r\n  background-color: #feb904;\r\n  border-radius: 3px;\r\n}\r\n\r\n.border-light {\r\n  border-color: #f1f2f3 !important;\r\n}\r\n\r\n.bt-1 {\r\n  border-top: 1px solid #ebebeb !important;\r\n}\r\n\r\n.publisher {\r\n  position: relative;\r\n  display: -webkit-box;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  align-items: center;\r\n  padding: 12px 20px;\r\n  border: 2px solid #5f5555 !important;\r\n  border-radius: 10rem !important;\r\n  /* background-color: #f9fafb; */\r\n}\r\n\r\n.copybtn {\r\n  visibility: hidden;\r\n}\r\n\r\n.copybtn:hover {\r\n  visibility: hidden;\r\n}\r\n\r\n.publisher > *:first-child {\r\n  margin-left: 0;\r\n}\r\n\r\n.publisher > * {\r\n  margin: 0 8px;\r\n}\r\n\r\n.publisher-input {\r\n  -webkit-box-flex: 1;\r\n  flex-grow: 1;\r\n  border: none;\r\n  color: white;\r\n  /* font-weight: bold; */\r\n  outline: none !important;\r\n  background-color: transparent;\r\n}\r\n\r\nbutton,\r\ninput,\r\noptgroup,\r\nselect,\r\ntextarea {\r\n  /* font-family: Roboto, sans-serif; */\r\n  font-weight: 300;\r\n}\r\n\r\n.publisher-btn {\r\n  background-color: transparent;\r\n  border: none;\r\n  color: #8b95a5;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  overflow: -moz-hidden-unscrollable;\r\n  -webkit-transition: 0.2s linear;\r\n  transition: 0.2s linear;\r\n}\r\n\r\n.file-group {\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.publisher-btn {\r\n  background-color: transparent;\r\n  border: none;\r\n  color: #cac7c7;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  overflow: -moz-hidden-unscrollable;\r\n  -webkit-transition: 0.2s linear;\r\n  transition: 0.2s linear;\r\n}\r\n\r\n.file-group input[type='file'] {\r\n  position: absolute;\r\n  opacity: 0;\r\n  z-index: -1;\r\n  width: 20px;\r\n}\r\n\r\n.text-info {\r\n  color: #48b0f7 !important;\r\n}\r\n\r\n.overFLOW {\r\n  overflow-y: scroll !important;\r\n  height: 450px !important;\r\n}\r\n\r\n.no-overFLOW {\r\n  /* overflow: hidden !important; */\r\n  /* overflow-y: hidden !important;\r\n  overflow-x: hidden !important; */\r\n}\r\n\r\n.polaroid {\r\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\r\n  text-align: center;\r\n}\r\n\r\n.bg-color-lite {\r\n  background-color: #d8d8d8;\r\n}\r\n\r\n.customChatContainer {\r\n  width: 80vw !important;\r\n}\r\n\r\n.copy-icon {\r\n  transition: all 0.2s;\r\n}\r\n\r\n.copy-icon:active {\r\n  /* background-color: gray; */\r\n  /* border-radius: 10rem; */\r\n}\r\n\r\n.copy-icon:hover {\r\n  filter: brightness(1.05);\r\n  transform: translateY(-5px);\r\n  /* box-shadow: 0px 30px 200px rgba(255, 255, 255, 0.7); */\r\n}\r\n\r\n@font-face {\r\n  font-family: 'SamuraiFont';\r\n  src: url('./mrrobot.ttf') format('truetype');\r\n  /* src: url('./nothing.ttf') format('truetype'); */\r\n}\r\n\r\n.nothing-font {\r\n  font-family: 'SamuraiFont', sans-serif;\r\n}\r\n\r\n.btn-and-loader {\r\n  display: flex !important;\r\n}\r\n.tl-update-loader {\r\n  margin-top: 0.5rem;\r\n  margin-left: 0.5rem;\r\n  padding: 0.8rem;\r\n}\r\n\r\n.privacy-btn {\r\n  border: none !important;\r\n}\r\n\r\n.float-right {\r\n  float: right;\r\n}\r\n.teams-container img {\r\n  width: fit-content;\r\n  margin: 0 auto;\r\n}\r\n.jtk-demo-canvas {\r\n  height: 88vh !important;\r\n}\r\n.footer {\r\n  position: absolute !important;\r\n  bottom: 0 !important;\r\n  margin: 0 !important;\r\n  left: 0;\r\n  right: 0;\r\n  padding: 0 !important;\r\n}\r\n\r\n.teams-container .MuiCardHeader-content {\r\n  color: #ebebeb !important;\r\n}\r\n\r\n.teams-container .MuiCardHeader-subheader {\r\n  color: #ebebeb !important;\r\n}\r\n\r\n.teams-container .MuiSvgIcon-root {\r\n  color: #ebebeb !important;\r\n}\r\n.teams-container .MuiChip-filled {\r\n  color: #ebebeb !important;\r\n}\r\n.h-v_center {\r\n  /* position: relative;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%); */\r\n  float: right;\r\n}\r\n.licenseDetails {\r\n  display: inline-block;\r\n  padding: 0.7rem 1rem;\r\n  border-radius: 10px;\r\n  margin-bottom: 5px;\r\n  background-color: #1f1d1d;\r\n  color: rgb(163, 193, 217);\r\n}\r\n.license_d-flex {\r\n  display: flex;\r\n  flex: 1 1 calc(25% - 30px);\r\n}\r\n.license-details {\r\n  /* border: 3px solid rgb(67, 63, 63); */\r\n  padding: 10px;\r\n  margin: 0 auto;\r\n}\r\n.license-details p {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: baseline;\r\n}\r\n.browse {\r\n  border-left: 2px solid gray;\r\n  background-color: gray;\r\n  padding: 1rem;\r\n  position: relative;\r\n  right: -1rem;\r\n}\r\n\r\n.license_modal .modal-content {\r\n  width: 70% !important;\r\n  margin: auto !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
